import { simpleAxios } from "@/utils/http";
import type { AxiosResponse } from "axios";
import { defineStore, acceptHMRUpdate } from "pinia"
import i18n from "@/utils/i18n";
import { getAvailableLanguagesKeys } from "@/lang/config";
const { t } = i18n.global
export const useCollaboStore = defineStore("collabo", {
	state: () => ({
        collaboData:{},
		teams: [],
		current_collabo_team: {},
		ws: null as WebSocket | null,
        challengesData: [],
        collaboConstructionData: {},
        collaboConstructionTransatcions:[],
        showErrorModal: false,
        showCorrectModal: false,
        showGiveMaterialDialog: false,
        timerFinish: null as number | null,
        timerInterval: null as NodeJS.Timeout | null,
        currentTime: Math.floor(Date.now() / 1000),
	}),
	actions: {
        async getConstructionTransactions(api_key:string)
        {
            try {
                const response: AxiosResponse = await simpleAxios("get", "collabo/get_construction_data_team/" + api_key, {})
                this.collaboConstructionTransatcions = response.data
            } catch (e) {
                console.warn('getConstructionTransactions failed', e)
            }
        },
        async fetchCollaboData(api_key:string)
        {
            try {
                const response: AxiosResponse = await simpleAxios("get", "events/event_full/" + api_key, {})
                this.collaboData = response.data
            } catch (e) {
                console.warn('fetchCollaboData failed', e)
            }
        },
        async startGame(api_key:string)
        {
            await simpleAxios("post", "collabo/start_game/" + api_key, {})
            .then((response: AxiosResponse) => {
                // this.collaboData = response.data
            })
            .catch((e: any) => {
                console.log(e);
            });
        },
        async getChallengesdata(api_key:string)
        {
            await simpleAxios("get", "collabo/get_challenge_data/" + api_key, {})
            .then((response: AxiosResponse) => {
                this.challengesData = response.data
            })
            .catch((e: any) => {
                console.log(e);
            });
        },
        async getConstructionData(api_key:string)
        {
            await simpleAxios("get", "collabo/get_construction_data/" + api_key, {})
            .then((response: AxiosResponse) => {
                this.collaboConstructionData = response.data
            })
        },
        updateTimer() {
            const collaboData = this.collaboData as any
            // Check for inner_timer_finish (instructor view) first
            if (collaboData?.inner_timer_finish) {
                // Handle both Date objects and timestamps
                if (collaboData.inner_timer_finish instanceof Date) {
                    this.timerFinish = Math.floor(collaboData.inner_timer_finish.getTime() / 1000)
                } else if (typeof collaboData.inner_timer_finish === 'string') {
                    // If it's a date string, parse it
                    this.timerFinish = Math.floor(new Date(collaboData.inner_timer_finish).getTime() / 1000)
                } else {
                    // Assume it's already a timestamp (in seconds)
                    this.timerFinish = collaboData.inner_timer_finish
                }
            } 
            // Fallback to time_challenge_round (player view)
            else if (collaboData?.time_challenge_round) {
                // Handle both Date objects and timestamps
                if (collaboData.time_challenge_round instanceof Date) {
                    this.timerFinish = Math.floor(collaboData.time_challenge_round.getTime() / 1000)
                } else if (typeof collaboData.time_challenge_round === 'string') {
                    // If it's a date string, parse it
                    this.timerFinish = Math.floor(new Date(collaboData.time_challenge_round).getTime() / 1000)
                } else {
                    // Assume it's already a timestamp (in seconds)
                    this.timerFinish = collaboData.time_challenge_round
                }
            }
        },
        startTimerInterval() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval)
            }
            this.timerInterval = setInterval(() => {
                this.currentTime = Math.floor(Date.now() / 1000)
            }, 1000)
        },
        stopTimerInterval() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval)
                this.timerInterval = null
            }
        },
        clearDemoProgress() {
            this.challengesData = []
            this.collaboConstructionTransatcions = []
            this.current_collabo_team = {}
            this.showErrorModal = false
            this.showCorrectModal = false
            this.showGiveMaterialDialog = false
            this.timerFinish = null
            this.stopTimerInterval()
        },
        /**
         * Generic debug helper to exercise getNextObjective with custom data.
         * Call from console/devtools, e.g.:
         *
         *   useCollaboStore().debugSetObjectiveData({
         *     constructionData: {
         *       1: { req: {} },
         *       2: { req: { 1: 2 } },
         *     },
         *     transactions: [
         *       { id: 1, construction_id: 1, status: 1 },
         *     ],
         *   })
         */
        debugSetObjectiveData(payload: {
            constructionData: Record<number, { req?: Record<number, number> }>,
            transactions: Array<{ id: number; construction_id: number; status: number; team?: number }>
        }) {
            this.collaboConstructionData = payload.constructionData as any
            this.collaboConstructionTransatcions = payload.transactions.map((tx) => ({
                team: 1,
                data_construction: {},
                ...tx,
            })) as any

            // eslint-disable-next-line no-console
            console.log("debugSetObjectiveData → getNextObjective:", (this as any).getNextObjective)
        }
	},

	persist: {
		// paths: ["events"]
	},
	getters:{
        getTeamData: state => (teamId: number) => {
            return state.teams.find((team: any) => team.id == teamId)
        },
        getTeamChallenge: state => () => {
            return state.challengesData.find(
                (challenge: any) => challenge.id 
                === (state.current_collabo_team as any).challenge_active)
        },
        getChallengeTeams: state => (challengeId: number) => {
            return state.teams.filter((team: any) => team.challenge_active === challengeId)
        },
        getMaterial:state => (materialId: number) => {
            const key = "material_" + materialId;
            const material_info:any ={
                image: (state.collaboData as any).preset[key + "_image"]
            }
            for (const lang of getAvailableLanguagesKeys()) {
                material_info["name_" + lang] = (state.collaboData as any).preset[key + "_name_" + lang];
            }
            return material_info;

        },
        getMaterialPlayer:state => (materialId: number) => {
            const team = state.current_collabo_team as any
            if (!team?.material_list) {
                return 0
            }
            return team.material_list[materialId] || 0
        },
        getConstruction:state => (constructionId: number) => {
            if (!state.collaboData.preset) {

                const null_info:any = {
                    image: "",
                }
                for (const lang of getAvailableLanguagesKeys()) {
                    null_info["name_" + lang] = "";
                }
                return null_info;
            }
            const key = "construction_" + constructionId;
            const construction_info:any ={
                image: (state.collaboData as any).preset[key + "_image"]
            }
            for (const lang of getAvailableLanguagesKeys()) {
                construction_info["name_" + lang] = (state.collaboData as any).preset[key + "_name_" + lang];
            }
            console.log(construction_info)
            return construction_info;
        },
        // Full construction cost entry as received from backend.
        // This may include per-material costs (keys 1..4), points, and `req` (building dependencies).
        getConstructionCost: state => (constructionId: number) => {
            return (state.collaboConstructionData as any)[constructionId] || {}
        },
        getTotalConstruction: state => () => {
            const construction_data: Record<number, number> = {}
            for (const index in state.collaboConstructionTransatcions) {
                const construction = (state.collaboConstructionTransatcions as any)[index]
                if (construction.status === 1) {
                    const id = Number(construction.construction_id)
                    construction_data[id] = (construction_data[id] || 0) + 1
                }
            }
            return construction_data
        },
        getConstructionCanBuild: state => (constructionId: number) => {
            const game = state.collaboData as any

            // Recompute totals locally to avoid relying on other getters' implementation details
            const totals: Record<number, number> = {}
            for (const index in state.collaboConstructionTransatcions) {
                const construction = (state.collaboConstructionTransatcions as any)[index]
                if (construction.status === 1) {
                    const id = Number(construction.construction_id)
                    totals[id] = (totals[id] || 0) + 1
                }
            }

            // Special case for final-round buildings (8, 9, 10):
            // - Only available when final_construction_round is active
            // - Hard limit of 2 completed constructions per type
            if ([8, 9, 10].includes(constructionId)) {
                if (!game || !game.final_construction_round) {
                    return false
                }
                if ((totals[constructionId] || 0) >= 2) {
                    return false
                }
            }

            const entry = (state.collaboConstructionData as any)[constructionId]
            const req = entry?.req || {}

            for (const materialId in req) {
                const id = Number(materialId)
                if ((totals[id] || 0) < Number(req[materialId])) {
                    return false
                }
            }
            return true
        },
        getBuildings: (state) => () => 
        {
            const buildings = [] as any[]
            state.collaboConstructionTransatcions.forEach((transaction: any) => {
                if(transaction.status == 1) {
                    buildings.push(transaction) 
                }
            })
            return buildings.sort((a, b) => b.id - a.id)
        },
        getPlayerInConstruction: (state) => () => {
            const teamId = String(state.current_collabo_team.id);
          
            const construction = state.collaboConstructionTransatcions.find((construction) => {
              // direct match
              if (construction.status != 0) return false;

              if (String(construction.team) === teamId) return true;
          
              // check inside data_construction keys
              if (construction.data_construction) {
                return Object.keys(construction.data_construction).includes(teamId);
              }
          
              return false;
            });
          
            return construction;
        },
        getMaterialInConstruction: (state) => () => {
            const construction = state.getPlayerInConstruction();
            if (construction) {
                if (state.current_collabo_team.id in construction.data_construction) {
                    return construction.data_construction[state.current_collabo_team.id];
                }
                return {"1":0,"2":0, "3":0, "4":0};
            }
            return {"1":0,"2":0, "3":0, "4":0};
        },
        getTotalMaterialInConstruction:(state) => (constructionTransaction: object) => {
            const result = Object.values(constructionTransaction.data_construction).reduce((acc, obj) => {
                for (const [key, value] of Object.entries(obj)) {
                    acc[key] = (acc[key] || 0) + value;
                }
                return acc;
            }, {});
            return result;
        },
        getNextObjective: (state) => {
            const constructionData = state.collaboConstructionData as any
            if (!constructionData || !Object.keys(constructionData).length) {
                return null
            }

            const game = state.collaboData as any

            // Totals per construction id (completed constructions only)
            const totals: Record<number, number> = {}
            for (const index in state.collaboConstructionTransatcions) {
                const construction = (state.collaboConstructionTransatcions as any)[index]
                if (construction.status === 1) {
                    const id = Number(construction.construction_id)
                    totals[id] = (totals[id] || 0) + 1
                }
            }

            // FINAL CONSTRUCTION ROUND (activated by GM): override normal objectives.
            // Objective: build at least 1 of each (8, 9, 10).
            // Teams are still allowed to build up to 2 of each (enforced elsewhere),
            // so public ranking may show values like 2/1.
            if (game && game.final_construction_round) {
                const finalIds = [8, 9, 10]
                const requirements = finalIds.map((depId) => ({
                    depId,
                    needed: 1,
                    built: totals[depId] || 0,
                }))
                return { targets: finalIds, requirements, isFinalRoundObjective: true }
            }

            const ids = Object.keys(constructionData)
                .map((id) => Number(id))
                .sort((a, b) => a - b)

            // Build objective blocks: group constructions by identical req signature.
            // Each block represents "if you build req deps, you unlock these constructions".
            const blocksBySignature: Record<string, { req: Record<string, number>; unlocks: number[] }> = {}
            for (const id of ids) {
                const entry = constructionData[id]
                if (!entry || !entry.req || !Object.keys(entry.req).length) continue
                const req = entry.req as Record<string, number>
                const signature = Object.entries(req)
                    .map(([k, v]) => [String(k), Number(v)])
                    .sort((a, b) => Number(a[0]) - Number(b[0]))
                    .map(([k, v]) => `${k}:${v}`)
                    .join('|')
                if (!blocksBySignature[signature]) {
                    blocksBySignature[signature] = { req, unlocks: [] }
                }
                blocksBySignature[signature].unlocks.push(id)
            }

            const blocks = Object.values(blocksBySignature).sort((a, b) => {
                const minA = Math.min(...a.unlocks)
                const minB = Math.min(...b.unlocks)
                return minA - minB
            })

            // Find the first not-yet-met block: that determines the current objective.
            for (const block of blocks) {
                const requirements = Object.entries(block.req).map(([depId, needed]) => {
                    const numericDepId = Number(depId)
                    const built = totals[numericDepId] || 0
                    return {
                        depId: numericDepId,
                        needed: Number(needed),
                        built,
                    }
                })

                const allMet = requirements.every((r) => r.built >= r.needed)
                if (allMet) continue

                const targets = requirements.map((r) => r.depId)
                return { targets, unlocks: block.unlocks, requirements }
            }

            return null
        },
        // Phase index by construction block (same as RankingPublicCollabo objective: 0=1,2 | 1=3,4 | 2=5,6 | 3=7).
        getConstructionPhaseIndex: () => (constructionId: number): number => {
            if (constructionId <= 2) return 0
            if (constructionId <= 4) return 1
            if (constructionId <= 6) return 2
            return 3
        },
        // Current phase index from objective.targets (use getNextObjective().targets so check matches public ranking).
        getCurrentPhaseIndexFromTargets: () => (targets: number[]): number => {
            if (!targets || !targets.length) return 3
            if (targets.some((t: number) => t === 1 || t === 2)) return 0
            if (targets.some((t: number) => t === 3 || t === 4)) return 1
            if (targets.some((t: number) => t === 5 || t === 6)) return 2
            return 3
        },
        timerFinishDate: (state) => {
            if (!state.timerFinish) return new Date()
            return new Date(state.timerFinish * 1000)
        },
        getTeamRanking: state => () => {
            const teams = (state.teams as any[]).map((entry: any) => {
                const team = entry?.team ?? entry
                const materialList = entry?.material_list ?? team?.material_list ?? {}
                const total = Object.values(materialList).reduce((sum: number, val: any) => sum + (Number(val) || 0), 0)
                return {
                    ...entry,
                    full_name: `${team?.name_id ?? ''} - ${team?.name ?? ''}`.trim() || '—',
                    material_list: materialList,
                    total
                }
            })
            return teams.sort((a: any, b: any) => (a.total ?? 0) - (b.total ?? 0))
        }
        
    
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useCollaboStore, import.meta.hot))
}
